import React from 'react';
import PropTypes from 'prop-types';
import classes from 'classnames';
import Modal from '../../components/Modal';
import Login from './components/login';
import ResetPassword from './components/resetPasword';
import SuccessRegister from './components/successRegister';
import SuccessSendEmailRecetPass from './components/succsesSendEmailResetPass';

class Auth extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isAuth: false,
      isShow: false,
      isShowLogin: false,
      isShowRegister: false,
      isShowResetPassword: false,
      isShowSuccessResetPasswordSendEmail: false,
      emailForResetPassword: '',
      registerEmail: ''
    }
  }

  static propTypes = {
    auth: PropTypes.object,
    hideAll: PropTypes.func,
    submitLogin: PropTypes.func,
    showResetPassword: PropTypes.func,
    resetPasswordSendEmail: PropTypes.func,
  };

  componentWillMount() {
    this.setState({
      isShow: this.props.auth.isShow,
      isShowLogin: this.props.auth.isShowLogin,
      isShowRegister: this.props.auth.isShowRegister,
      isShowResetPassword: this.props.auth.isShowResetPassword,
      isShowSuccessResetPasswordSendEmail: this.props.auth.isShowSuccessResetPasswordSendEmail,
      registerEmail: this.props.auth.registerEmail,
    })
  }

  componentWillReceiveProps(next) {
    this.setState({
      isShow: next.auth.isShow,
      isShowLogin: next.auth.isShowLogin,
      isShowRegister: next.auth.isShowRegister,
      isShowResetPassword: next.auth.isShowResetPassword,
      isShowSuccessResetPasswordSendEmail: next.auth.isShowSuccessResetPasswordSendEmail,
      registerEmail: next.auth.registerEmail,
    })
  }

  showResetPassword = (email) => {
    this.setState({emailForResetPassword: email}, () => {
      this.props.showResetPassword()
    })
  };

  render() {
    const {
      isAuth,
      isShow,
      isShowLogin,
      isShowRegister,
      isShowResetPassword,
      emailForResetPassword,
      registerEmail,
      isShowSuccessResetPasswordSendEmail,
    } = this.state;

    const {
      auth,
      hideAll,
      submitLogin,
      resetPasswordSendEmail,
    } = this.props;

    if (isAuth) {
      return null;
    }

    return (
      <Modal
        classModal={classes('authentication', {registration: isShowRegister || isShowLogin})}
        isOpen={isShow}
        onRequestClose={hideAll}
        showCloseIcon
        shouldCloseOnOverlayClick={false}
      >
        {isShowLogin &&
        <Login
          submit={(data) => submitLogin(data)}
          showResetPassword={this.showResetPassword}
          error={auth.error}
          hideAll={hideAll}
        />
        }
        {
          isShowResetPassword &&
          <ResetPassword
            email={emailForResetPassword}
            sendEmail={resetPasswordSendEmail}
            error={auth.error}
          />
        }
        {
          auth.successRegister &&
          <SuccessRegister
            email={registerEmail}
            hideAll={hideAll}
          />
        }
        {
          isShowSuccessResetPasswordSendEmail &&
            <SuccessSendEmailRecetPass
              email={emailForResetPassword}
              hideAll={hideAll}
            />
        }
      </Modal>
    )
  }
}

export default Auth;




// WEBPACK FOOTER //
// ./src/app/containers/Auth/Component.js